import styled from '@emotion/styled';
import { ThemeProvider } from '@mui/material/styles';
import { Button } from '@ui/core/button/Button';
import { IconSidebar } from '@ui/core/icons';
import { theme } from '@ui/theme/cobrainer-theme';

import { CompanyLogoV2 } from './CompanyLogoV2';
import { useNavigationMenu } from './NavigationMenuContext';
import { DrawerHeader, NavigationMenuV2 } from './NavigationMenuV2';

import type { FunctionComponent } from 'react';

const ToolbarContainer = styled('section')(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.gray[200],
    display: 'grid',
    gap: theme.spacing['3xl'],
    gridTemplateColumns: 'auto 160px 1fr',
    paddingLeft: theme.spacing.xxl,
    paddingRight: theme.spacing.xxl,
}));

export const MenuBarV2: FunctionComponent = () => {
    const { toggleMenu } = useNavigationMenu();

    return (
        <ThemeProvider theme={theme}>
            <ToolbarContainer>
                <DrawerHeader>
                    <Button iconOnly={true} style={{ marginLeft: '-0.60rem' }} variant="ghost" onClick={toggleMenu}>
                        <IconSidebar />
                    </Button>
                </DrawerHeader>
                <CompanyLogoV2 />
                <NavigationMenuV2 />
            </ToolbarContainer>
        </ThemeProvider>
    );
};
